function DeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18.286"
      data-name="DeleteIcon - Delete"
      viewBox="0 0 16 18.286"
    >
      <path
        fill="currentColor"
        d="M9.571 2.607h.857a.429.429 0 00.429-.429v-7.714a.429.429 0 00-.429-.429h-.857a.429.429 0 00-.429.429v7.715a.429.429 0 00.429.428zm5.857-12h-2.943l-1.214-2.025A1.9 1.9 0 009.8-12.25H6.2a1.9 1.9 0 00-1.47.832L3.515-9.393H.571A.572.572 0 000-8.821v.571a.572.572 0 00.571.571h.571v12a1.715 1.715 0 001.715 1.715h10.286a1.715 1.715 0 001.714-1.714v-12h.571A.572.572 0 0016-8.25v-.571a.572.572 0 00-.572-.572zm-9.291-1.039a.238.238 0 01.184-.1h3.358a.238.238 0 01.184.1l.624 1.039H5.514zm7.006 14.753H2.857v-12h10.286zM5.571 2.607h.857a.429.429 0 00.429-.429v-7.714a.429.429 0 00-.429-.429h-.857a.429.429 0 00-.429.429v7.715a.429.429 0 00.429.428z"
        data-name="Path 10615"
        transform="translate(0 12.25)"
      ></path>
    </svg>
  );
}

export default DeleteIcon;
